/* eslint-disable max-lines, extra-rules/no-commented-out-code */
/* eslint-disable max-statements */
/* eslint-disable camelcase */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import App from 'next/app';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import withRedux from 'next-redux-wrapper';
import withReduxSaga from 'next-redux-saga';
import {
  callNavigateAPIForExternalLinks,
  getBrandNameFromHref,
  getSubSetAPiConfigKey,
  isClient,
} from '@tcp/core/src/utils/utils';
import dynamic from 'next/dynamic';
import isEmpty from 'lodash/isEmpty';
import GlobalStyle from '@tcp/core/styles/globalStyles';
import getCurrentTheme from '@tcp/core/styles/themes';
import withLazyLoad from '@tcp/core/src/components/common/hoc/withLazyLoad';
import LabelsProvider from '@tcp/core/src/components/common/context/LabelsProvider';
import PageVisibility from '@tcp/web/src/components/common/molecules/PageVisibility';
import { subscribeScrollRestore, unSubscribeScrollRestore } from '@tcp/core/src/utils/utils.router';
import queryString from 'query-string';
import {
  bootstrapData,
  fetchPageLayout,
  SetTcpSegmentMethodCall,
  setAPIConfig,
  setBossBopisFlags,
  loadComponentLabelsData,
  setNonInventoryStagSessionFlag,
  getServerTime,
} from '@tcp/core/src/reduxStore/actions';
import {
  getAPIConfig,
  isDevelopment,
  isGymboree,
  checkIfUserInfoCallRequired,
  isSafariBrowser,
  queryModulesThatNeedRefresh,
  extractPID,
  createLayoutPath,
  pathHasHyphenSlash,
  setBossBopisEnabled,
  getURIForDeepLink,
  parseBoolean,
  fetchStoreIdFromUrlPath,
  getIfBotDevice,
  getViewportInfo,
} from '@tcp/core/src/utils';
import { initErrorReporter } from '@tcp/core/src/utils/errorReporter.util';
import { deriveSEOTags } from '@tcp/core/src/config/SEOTags.config';
import { openOverlayModal } from '@tcp/core/src/components/features/account/OverlayModal/container/OverlayModal.actions';
import { getProductDetails } from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.actions';
import { setSflId } from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import { getUserInfo } from '@tcp/core/src/components/features/account/User/container/User.actions';
import { CHECKOUT_ROUTES } from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import { getLocalStorage, setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import logger from '@tcp/core/src/utils/loggerInstance';
import { SLASH_C_ROUTE } from '@tcp/core/src/constants/plp.constants';
import Loader from '@tcp/core/src/components/common/molecules/Loader';
import AppBanner from '@tcp/core/src/components/common/atoms/AppBanner';
import {
  getUserInfoFetchingState,
  getIsRegisteredUserCallDone,
  getLoadingInProcess,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { getCookieToken } from '@tcp/core/src/components/features/account/NavigateXHR/container/NavigateXHR.selectors';
import { setNavigateCookieToken } from '@tcp/core/src/components/features/account/NavigateXHR/container/NavigateXHR.action';
import {
  getBootstrapError,
  getIsExtendedDisplay,
  getIsRedesignedPdpDesktopView,
  getIsSlpDesktopView,
  getIsBuyMorePromoEnabled,
  getIsReloadOnInactivity,
  getInActivityTimeInterval,
  getIsChatBotEnabled,
  getIsNewPJPPDPRedesignEnabled,
  getFetchClosestStore,
  getAfterPayParam,
  getIsNewLoginScreen,
  getIsReloadOnInactivityPostSpecifiedTime,
  getTimeToReloadPageInEST,
  getConfirmationPageHeaderAndButton,
  getShowSiteCookiesDisclaimer,
  getIsHomepageFullPageWidthEnabled,
  getLoginFlowUXEnhancement,
  getRedirectModalDisclaimer,
  getIsFooterRedesignEnabled,
  getConfettiAnimationParams,
  getIsDyAbTestEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  HotfixBrowserContext,
  HotfixPropsContext,
} from '@tcp/core/src/components/common/context/HotfixContext';
import { readCookie, setCookie, generateSessionId } from '@tcp/core/src/utils/cookie.util';
import { API_CONFIG } from '@tcp/core/src/services/config';
import {
  setSessionStorage,
  getSessionStorage,
  removeSessionStorage,
} from '@tcp/core/src/utils/utils.web';
import { fetchNavigationData } from '@tcp/core/src/components/features/content/Navigation/container/Navigation.actions';
import { getStoresByCoordinates } from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.actions';
import {
  setAbTestData,
  fetchAbTestData,
  fetchDyABTestsData,
} from '@tcp/core/src/components/common/molecules/abTest/abTest.actions';
import { fetchAllPromotions } from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.action';
import DynamicModule from '@tcp/core/src/components/common/atoms/DynamicModule';
import { getCurrentStoreInfo } from '@tcp/core/src/components/features/storeLocator/StoreDetail/container/StoreDetail.actions';
import {
  getCurrentStore,
  formatCurrentStoreToObject,
} from '@tcp/core/src/components/features/storeLocator/StoreDetail/container/StoreDetail.selectors';
import { getLoginV2FlowEnabled } from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import FooterSkeleton from '@tcp/web/src/components/features/content/Footer/views/FooterSkeleton.view';
import {
  setLabelsData,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import ConfettiCelebration from '@tcp/core/src/components/common/molecules/Confetti';
import SiteMaintenanceBannerContainer from '@tcp/core/src/components/common/molecules/SiteMaintenanceBanner/container/SiteMaintenanceBanner.container';
import { getDyRequestContextByPage } from '@tcp/core/src/components/common/molecules/abTest/utils/dyRequestContext';
import PageMinHeight from '../constants/minHeightStyle';
import GlobalModals from '../components/common/molecules/GlobalModals';
import SEOTags from '../components/common/atoms/SEOTags/SEOTags';
import configStore from '../reduxStore/store/configureStore';
import RouteTracker from '../components/common/atoms/RouteTracker';
import UserTimingRouteHandler from '../components/common/atoms/UserTimingRouteHandler';
import AbTestPathTracker from '../components/common/atoms/AbTestPathTracker';
import constants from '../constants';
import setDeviceTier from '../utils/device-tiering';
import modalStyles from '../components/common/molecules/PageVisibility/PageVisibility.style';
import SiteCookiesDisclaimer from '../components/features/content/Footer/molecules/SiteCookiesDisclaimer/views/SiteCookiesDisclaimer';
import RedirectModalContainer from '../components/features/content/Footer/molecules/RedirectModal/container/RedirectModalContainer';
import ThirdPartyScript from '../components/common/atoms/ThirdPartyScript/ThirdPartyScript';
import HeaderNew from '../components/features/content/HeaderNew';

const EXCLUDED_ROUTES_FOR_USER_INFO = ['/checkout'];

const PAGE_ROUTES = {
  OLD_PLP: '/ProductListing',
  NEW_PLP: '/CategoryListingPage',
  SEARCH: '/SearchDetail',
  BAG: '/Bag',
  SHOP_THIS_STORE: '/ShopThisStore',
  ACCOUNT: '/account',
  HOME: '/home',
};

const HelpMenu = dynamic(() =>
  import(/* webpackChunkName: "help-menu" */ '@tcp/core/src/components/common/organisms/HelpMenu')
);

const PageVisibilityModal = dynamic(
  () =>
    import(
      /* webpackChunkName: "page-visibility" */ '@tcp/core/src/components/common/molecules/Modal'
    ),
  { ssr: false }
);

const Footer = dynamic(
  () =>
    import(
      /* webpackChunkName: "footer-chunk" */ '../components/features/content/Footer/container/Footer.container'
    ),
  {
    loading: () => {
      return <FooterSkeleton isPreCheckoutFlow={false} isFooterRedesignEnabled={true} />;
    },
  }
);

/**
 * TO update the payload in case component needs to be loaded at server side
 * @param {} req
 * @param {*} payload
 * @param {*} Component
 */
const updatePayload = (req, payload, Component) => {
  let updatedPayload = { ...payload };
  const { pageInfo } = Component;
  const { staticPage, paramName, pathPrefix } = pageInfo || {};

  // This check ensures this block is executed once since Component is not available in first call
  if (pageInfo) {
    updatedPayload = {
      ...pageInfo,
      ...updatedPayload,
    };
    // This will check when page has to be rendered at server side and includes multiple urls
    if (staticPage && paramName) {
      // staticPage - this var will be passed inside component pageinfo
      // paramName - this keyword will have the variable name to page the page url from the request.
      const dynamicPageName = req.params ? req.params[paramName] : '';
      if (!constants.staticPagesWithOwnTemplate.includes(dynamicPageName) && dynamicPageName) {
        const pathName = `${pathPrefix}${dynamicPageName}`;
        updatedPayload = { ...updatedPayload, name: pathName };
      }
    }
    if (req && req.headers) {
      updatedPayload = {
        ...updatedPayload,
        pageData: {
          ...updatedPayload.pageData,
          pageReferer: req.headers.referer,
        },
      };
    }
  }
  return updatedPayload;
};

class TCPWebApp extends App {
  globalGenericLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_GENERIC_LABELS,
    GlobalGenericLabels
  );

  static siteConfigSet = false;

  constructor(props) {
    super(props);
    this.theme = getCurrentTheme();
    this.state = {
      isReloadEnabled: false,
      isLabelsLoaded: true,
      hasMounted: false,
    };
    // Initializing the state with default NJ
    const { store, router = {} } = this.props;
    if (typeof window !== 'undefined') {
      setLabelsData(window.labelsData);
      delete window.labelsData;
      const script = document.getElementById('labelsScript');
      script?.parentNode?.removeChild(script);
    }
    const isPdpPage = router?.asPath?.includes('/p/');
    if (isPdpPage) {
      const state = store.getState();
      const { session } = state;
      store.dispatch(setBossBopisFlags(setBossBopisEnabled('NJ', session)));
    }
    this.pageVisibilityTimerRef = React.createRef(null);
  }

  // eslint-disable-next-line complexity
  static async getInitialProps({ Component, ctx }) {
    const { req, res, store, isServer, query, pathname } = ctx;
    let reqUrl = '';

    // Error Page Handling
    if (res && res.statusCode && res.statusCode !== 200) {
      return {};
    }

    if (req) {
      ctx.req.device = {
        type: TCPWebApp.getDeviceType(req),
      };
    }
    const isBotDevice = getIfBotDevice(req);
    if (req) {
      const { url = '' } = req;
      reqUrl = url;
    }

    let productDetailState = true;
    let isValidLayoutPage = true;
    let isValidStorePage = true;
    let bootstrapPayload;
    let globalProps = {};
    if (isServer) {
      bootstrapPayload = TCPWebApp.createPayloadOfBootstrap(Component, ctx);
      const { apiConfig, originalUrl, name: layoutPageName } = bootstrapPayload;
      logger.info(
        `oneBuildLog#apiConfig#App#NonRedux: ${JSON.stringify(getSubSetAPiConfigKey(apiConfig))}`
      );
      await store.dispatch(setAPIConfig(apiConfig));
      globalProps = await TCPWebApp.loadGlobalData(Component, ctx, {}, bootstrapPayload);
      const asPath =
        originalUrl &&
        (originalUrl.indexOf('?') < 0
          ? originalUrl.split('/').pop()
          : originalUrl.substring(originalUrl.lastIndexOf('/') + 1, originalUrl.indexOf('?')));

      const brandName = getBrandNameFromHref(asPath);
      if (reqUrl.includes('/p/')) {
        const productID = reqUrl.split('/p/')[1];
        const productIDWithoutQuery = productID && productID.split('?')[0];
        const pid = extractPID(productIDWithoutQuery);

        const {
          unbxdUrl,
          unbxdSiteKey,
          unbxdApiKey,
          unbxdSiteKeyGYM,
          unbxdSiteKeyTCP,
          unbxdApiKeyTCP,
          unbxdApiKeyGYM,
        } = apiConfig;
        let unbxdApiKeyValue = '';
        let unbxdSiteKeyValue = '';
        let originalURL = '';
        if (brandName) {
          unbxdApiKeyValue = brandName === 'GYM' ? unbxdApiKeyGYM : unbxdApiKeyTCP;
          unbxdSiteKeyValue = brandName === 'GYM' ? unbxdSiteKeyGYM : unbxdSiteKeyTCP;
          originalURL = `${unbxdUrl}/${unbxdApiKeyValue}/${unbxdSiteKeyValue}`;
        } else {
          originalURL = `${unbxdUrl}/${unbxdApiKey}/${unbxdSiteKey}`;
        }

        if (TCPWebApp.getUnbxdKeys(unbxdSiteKey, unbxdApiKey, unbxdUrl)) {
          await new Promise((resolve) => {
            const payload = {
              productColorId: pid,
              resolve,
              originalURL,
              apiConfig,
              otherBrand: brandName,
              bootstrapPayload,
            };
            return store.dispatch(getProductDetails({ ...payload }));
          });
          const getProductState = TCPWebApp.getProductState(store);
          productDetailState = TCPWebApp.getProductDetailsState(
            getProductState,
            productDetailState
          );
        }
      }

      if (reqUrl.includes('/store/')) {
        await TCPWebApp.triggerStorePageCall(store, query, apiConfig);
        isValidStorePage = TCPWebApp.isValidStoreData(store);
      }
      if (layoutPageName && layoutPageName !== 'home') {
        await new Promise((resolve) => {
          return store.dispatch(
            fetchPageLayout({
              pageName: layoutPageName,
              layoutName: null,
              isClpPage: false,
              resolve,
              apiConfig,
            })
          );
        });
        const layoutState = TCPWebApp.getLayoutState(store);
        const stateLayoutPageName =
          layoutPageName && pathHasHyphenSlash(layoutPageName)
            ? createLayoutPath(layoutPageName)
            : layoutPageName;
        const contentSlots =
          layoutState && layoutState[stateLayoutPageName]
            ? layoutState[stateLayoutPageName].slots || []
            : [];
        if (!contentSlots.length) {
          isValidLayoutPage = false;
        }
      }
    }
    if (productDetailState && isValidLayoutPage && isValidStorePage) {
      let apiConfig;
      if (isServer) {
        const {
          locals: { apiConfig: config },
        } = res;
        apiConfig = config;
        const { graphql_endpoint_url_server } = apiConfig;
        logger.info(`GraphQL Endpoint Stateless Server: ${graphql_endpoint_url_server}`);
      } else {
        apiConfig = getAPIConfig();
        const { graphql_endpoint_url } = apiConfig;
        logger.info(`GraphQL Endpoint Stateless Server: ${graphql_endpoint_url}`);
      }
      const akamaiRequestHeader = req?.headers['x-akamai-edgeworker-request'] === 'minipdp';
      const isPdpPage = pathname === '/ProductDetail';
      const pageProps = await TCPWebApp.loadComponentData(
        Component,
        ctx,
        Object.assign(
          {
            setResStatusNotFound: () => {
              if (res) res.statusCode = 404;
            },
            isBotDevice,
            isMiniPDP: isPdpPage && akamaiRequestHeader,
            setResServerError: (errMssg) => {
              if (res) {
                res.statusCode = 500;
                res.setHeader('ErrorCode', errMssg);
              }
            },
          },
          globalProps
        ),
        apiConfig,
        bootstrapPayload
      );
      const {
        GTM_CONTAINER_ID,
        PEGA_MASHUP_SCRIPT_URL,
        PEGA_HELPER_FILE_NAME,
        ADOBE_CONTAINER_ID,
      } = apiConfig;
      const isChatBotEnabled = getIsChatBotEnabled(store.getState());
      return {
        pageProps,
        GTM_CONTAINER_ID,
        ADOBE_CONTAINER_ID,
        PEGA_MASHUP_SCRIPT_URL,
        PEGA_HELPER_FILE_NAME,
        isChatBotEnabled,
      };
    }
    res.statusCode = 404;
    return {};
  }

  // eslint-disable-next-line complexity
  static createPayloadOfBootstrap(Component, { res, isServer, req }) {
    let payload = {};
    if (isServer) {
      const apiConfig = Object.assign({}, res.locals.apiConfig);
      const {
        device = {},
        originalUrl,
        headers: { cookie = {} },
      } = req;

      const isFlipUnbxdDrUrl = parseBoolean(readCookie('isFlipUnbxdDrUrl', cookie));
      if (isFlipUnbxdDrUrl) {
        apiConfig.isFlipUnbxdDrUrl = isFlipUnbxdDrUrl;
      }

      payload = {
        siteConfig: true,
        apiConfig,
        deviceType: device.type,
        originalUrl,
      };
      logger.info(
        'Global Data Loading, isPreview Mode ',
        apiConfig.isPreviewEnv,
        ',siteId',
        apiConfig.siteId
      );
      logger.info(
        ',oneBuildLog#ApiConfig#App#Redux',
        JSON.stringify(getSubSetAPiConfigKey(apiConfig))
      );
      // Get initial props is getting called twice on server
      // This check ensures this block is executed once since Component is not available in first call
      // This will be called when we need to include the layout call in bootstrap.
      payload = updatePayload(req, payload, Component);
    }
    return payload;
  }

  static triggerStorePageCall = async (store, query, apiConfig) => {
    const { storeStr = '' } = query;
    return new Promise((resolve) => {
      const payload = {
        storeID: fetchStoreIdFromUrlPath(storeStr),
        resolve,
        apiConfig,
      };
      return store.dispatch(getCurrentStoreInfo(payload));
    });
  };

  static isValidStoreData = (store) => {
    const state = store.getState();
    const currentStoreInfo = getCurrentStore(state);
    const formatStore = formatCurrentStoreToObject(currentStoreInfo) || {};

    return Object.keys(formatStore).length;
  };

  static getDeviceType = (req) =>
    req && req.headers && req.headers['x-bot-user'] ? 'bot' : undefined;

  static getUnbxdKeys = (unbxdSiteKey, unbxdApiKey, unbxdUrl) =>
    unbxdSiteKey && unbxdApiKey && unbxdUrl;

  static getProductState = (store) => store.getState() && store.getState().ProductDetail;

  static getLayoutState = (store) => store.getState() && store.getState().Layouts;

  static getProductDetailsState = (getProductState, productDetailState) =>
    getProductState && getProductState.currentProduct && getProductState.currentProduct.productId
      ? productDetailState
      : false;

  // this function gets the cookietoken value passed from cross-domain in url
  getCookieToken = (asPath) => {
    // this expression is to get the query strings
    const reg = new RegExp('[?&]ct=([^&#]*)', 'i');
    const cookieToken = reg.exec(asPath);
    return cookieToken && cookieToken.length ? cookieToken[1] : null;
  };

  // this function will check if ResetPassword overlay needs to be displayed on page load
  // it will check for em and logonPasswordOld
  checkForResetPassword = () => {
    const { router, store } = this.props;
    const { asPath } = router || {};
    const { em, logonPasswordOld } = (router && router.query) || {};
    if (em && logonPasswordOld) {
      // eslint-disable-next-line no-unused-expressions
      'standalone' in window.navigator &&
        document.location.replace(
          `${
            isGymboree() ? 'gym' : 'tcp'
          }://change-password/?logonPasswordOld=${logonPasswordOld}&em=${em}`
        );
      store.dispatch(
        openOverlayModal({
          component: 'login',
          componentProps: {
            queryParams: {
              em,
              logonPasswordOld,
            },
            currentForm: 'resetPassword',
          },
        })
      );
    } else {
      store.dispatch(
        getUserInfo({
          loadFavStore: true,
          ct: this.getCookieToken(asPath),
          router,
          source: 'firstload', // flag passed in the first load of the application
          refresh: true,
        })
      );
    }
  };

  deepLinkingCheck = () => {
    const {
      router: { asPath = '' },
    } = this.props;
    const parsedURL = queryString.parseUrl(asPath);
    if (parsedURL) {
      const {
        url,
        query: { deepLink = '' },
      } = parsedURL;
      if (deepLink.toLowerCase() === 'true' && 'standalone' in window.navigator && url) {
        document.location.replace(`${isGymboree() ? 'gym' : 'tcp'}://${getURIForDeepLink(url)}`);
      }
    }
  };

  checkBootstrapErrors = () => {
    const { isServer = false, pageProps, store } = this.props;
    const bootstrapErrorObject = getBootstrapError(store.getState());
    const isErrorInBootstrap = bootstrapErrorObject && bootstrapErrorObject.isErrorInBootstrap;
    if (isErrorInBootstrap && isServer && pageProps && pageProps.setResServerError) {
      pageProps.setResServerError(bootstrapErrorObject.bootstrapErrorCode);
    }
  };

  checkForCidParam = () => {
    const { router } = this.props;
    let val = 'false';
    if (
      router &&
      router.asPath &&
      router.asPath.includes('cid') &&
      !router.asPath.includes('utm_') &&
      !router.asPath.includes('icid')
    ) {
      val = 'true';
    }
    if (typeof window !== 'undefined') {
      setSessionStorage({ key: 'cidParam', value: val });
    }
  };

  setEDDSession = () => {
    const { router } = this.props;
    let val = false;
    if (router && router.asPath && router.asPath.indexOf('showEDD') > -1) {
      val = true;
    }
    const isEddSessionEnabled = parseBoolean(getSessionStorage('EDD_ENABLED'));
    if (!isEddSessionEnabled) {
      setSessionStorage({ key: 'EDD_ENABLED', value: val });
    }
  };

  setPromotionsData = (store) => {
    store.dispatch(fetchAllPromotions());
    const isBuyMoreSaveMoreEnabled = getIsBuyMorePromoEnabled(store.getState());
    if (isBuyMoreSaveMoreEnabled) {
      store.dispatch(getServerTime());
      this.serverTimeInterval = setInterval(() => {
        store.dispatch(getServerTime());
      }, 30 * 60 * 1000);
    }
  };

  emailCheckForFailSafe = () => {
    const { router } = this.props;
    const { asPath } = router;
    const pathname = asPath.split('/')[2];
    const contactValues = JSON.parse(getSessionStorage('emailForFailSafe'));
    const VenmoStatus = JSON.parse(getSessionStorage('isVenmoPayment'));
    if (pathname !== 'checkout') {
      if (contactValues) removeSessionStorage('emailForFailSafe');
      if (VenmoStatus) removeSessionStorage('isVenmoPayment');
    }
  };

  checkForCookieToken = (store) => {
    if (isSafariBrowser()) {
      const state = store.getState();
      const cookieTokenInStore = getCookieToken(state);
      const { brandId } = getAPIConfig();
      const cookieTokenInLocalStorage = getLocalStorage(`${brandId}_ct`);

      if (cookieTokenInLocalStorage && !cookieTokenInStore) {
        store.dispatch(
          setNavigateCookieToken({
            encodedcookie: cookieTokenInLocalStorage,
          })
        );
      }
    }
  };

  checkforSFLID = (store) => {
    const sflId = JSON.parse(getSessionStorage('SFL_ID'));
    if (sflId) {
      store.dispatch(setSflId(sflId));
    }
  };

  // Drop the 'LandingBrand' cookie
  setLandingBrandCookie = (brandId) => {
    const { landingSite } = API_CONFIG;
    const lsBrandCookie = readCookie(landingSite);
    if (lsBrandCookie) {
      return;
    }
    setCookie({
      key: landingSite,
      value: brandId,
    });
  };

  handleRouteChange = (url) => {
    const { store } = this.props;
    const isFetchingUserInfoData = getUserInfoFetchingState(store.getState());
    const isUserCallDone = getIsRegisteredUserCallDone(store.getState());
    if (
      !isUserCallDone &&
      checkIfUserInfoCallRequired(EXCLUDED_ROUTES_FOR_USER_INFO, url) &&
      !isFetchingUserInfoData
    ) {
      store.dispatch(getUserInfo({ refresh: true }));
    }
  };

  setAbTestestData = (store) => {
    const { abTestJSONEnabled } = getAPIConfig();
    const isDyAbTestEnabled = getIsDyAbTestEnabled();
    if (parseBoolean(abTestJSONEnabled) && !isDyAbTestEnabled) {
      const payload = { payload: {} };
      store.dispatch(fetchAbTestData(payload));
    } else if (isDyAbTestEnabled) {
      const payloadDyAb = getDyRequestContextByPage();
      store.dispatch(fetchDyABTestsData(payloadDyAb));
    } else if (window.ABTest && window.ABTestCallComplete) {
      const abtestObj = {
        abTest: window.ABTest || {},
        abTestComplete: true,
      };
      store.dispatch(setAbTestData(abtestObj));
      if (window.ABTest.isNonInventoryABTestEnabled) {
        store.dispatch(setNonInventoryStagSessionFlag(true));
      }
      window.ABTest = null;
    } else {
      const dispatchTimer = setTimeout(() => {
        const abtestObj = {
          abTest: window?.ABTest || {},
          abTestComplete: true,
        };
        store.dispatch(setAbTestData(abtestObj));
        if (window?.ABTest && window?.ABTest?.isNonInventoryABTestEnabled) {
          store.dispatch(setNonInventoryStagSessionFlag(true));
        }
        window.ABTest = null;
        clearTimeout(dispatchTimer);
      }, 1000);
    }
  };

  bindRouteChangeEvent = () => {
    const { router } = this.props;
    router.events.on('routeChangeComplete', this.handleRouteChange);
  };

  componentDidCatch(error) {
    const { sessionCookieKey } = API_CONFIG;
    logger.error('Error occurred in Web app.jsx file —> ComponentDidCatch: ', {
      error,
      extraData: {
        [sessionCookieKey]: generateSessionId(true),
        component: 'componentDidCatch inside _app.jsx',
      },
    });
  }

  // if user tries to navigate to a different location before page loads, wait for labels to complete to render.
  labelsCallBack = () => {
    const { isLabelsLoaded } = this.state;
    if (!isLabelsLoaded) {
      this.setState({
        isLabelsLoaded: true,
      });
    }
    this.labelsCallComplete = true;
  };

  handlePathChange = () => {
    const { router } = this.props;
    if (!this.labelsCallComplete) {
      this.setState({
        isLabelsLoaded: false,
      });
    }
    router.events.off('routeChangeComplete', this.handlePathChange);
  };

  handleRouteChangeStart = () => {
    if (window.LUX) {
      window.LUX.send();
      window.LUX.init();
    }
  };

  // used to see if labels get override due to concurrency.
  logLabelReceivedValue = () => {
    const freeShippingLabel = renderLabel(
      getDynamicLabelValues('dynamic.browse_d.lbl_ships_free_msg'),
      'lbl_ships_free_msg'
    );
    logger.info(`Issue#isFreeShippingLabel for translation validation: ${freeShippingLabel}`);
  };

  getPageIdFromPathname = (pathname) => {
    const pageIdMap = {
      Bag: 'Bag',
      SinglePageCheckout: 'Checkout',
      ProductDetail: 'p',
    };

    return pageIdMap[pathname];
  };

  getPageName = () => {
    if (window && window.location && window.location.pathname) {
      const pathname = window.location.pathname || '';
      if (pathname.includes('/p/')) return 'ProductDetail';
      if (pathname.includes('/bag')) return 'Bag';
      if (pathname.includes('/checkout')) return 'SinglePageCheckout';
    }
    return 'Home';
  };

  componentDidMount() {
    const { store, router } = this.props;
    const stateCookie = readCookie('tcpState');
    const state = store.getState();
    const { session } = state;
    const {
      envId,
      raygunApiKey,
      channelId,
      isErrorReportingBrowserActive,
      brandId,
      isPreviewEnv,
      isPageSpecificLabelEnabled,
      deploymentPacket,
      isEnableSpeedCurveSPA,
      isAutomationTC,
      isBotRequest,
    } = getAPIConfig();
    const isAutomationTCValue = parseBoolean(isAutomationTC);
    const isBotRequestValue = parseBoolean(isBotRequest);
    if (isEnableSpeedCurveSPA && window?.LUX && !isAutomationTCValue && !isBotRequestValue) {
      window.LUX.auto = false;
      router.events.on('routeChangeStart', this.handleRouteChangeStart);
    }

    const isLoginV2FlowEnabled = getLoginV2FlowEnabled(state);
    // commented below line in support to validate getToken is handled from backend, in case if it won't work have to uncomment below code.
    // store.dispatch(getToken());
    this.setState({ hasMounted: true });
    try {
      if (isErrorReportingBrowserActive && !isDevelopment()) {
        try {
          // eslint-disable-next-line global-require
          const rg4js = require('raygun4js');
          initErrorReporter({
            isServer: false,
            envId,
            raygunApiKey,
            channelId,
            isDevelopment: false,
            rg4js,
            deploymentPacket,
          });
        } catch (e) {
          // sometimes raygun is not initializing on client side and throwing exception,
          // which was blocking the subsequent did mount code.
          logger.error('error initializing raygun', e);
        }
      }

      if (!isPreviewEnv) {
        // skip this for preview
        logger.info('Checking for modules that need to be called on client side');
        queryModulesThatNeedRefresh(store);
      } else {
        logger.info('Skipping calls from client side as this is a preview environment.');
      }

      store.dispatch(
        fetchNavigationData({
          depth: 3,
          ignoreCache: true,
        })
      );
      if (parseBoolean(isPageSpecificLabelEnabled)) {
        store.dispatch(loadComponentLabelsData({ callBack: this.labelsCallBack }));
        router.events.on('routeChangeComplete', this.handlePathChange);
      }
      this.checkForResetPassword();
      this.deepLinkingCheck();
      this.bindRouteChangeEvent();
      this.checkForCidParam();
      this.checkForCookieToken(store);
      this.setLandingBrandCookie(brandId);
      store.dispatch(setBossBopisFlags(setBossBopisEnabled(stateCookie, session)));
      this.setAbTestestData(store);
      this.checkforSFLID(store);
      this.checkForDefaultAfterPayParam();
      this.setEDDSession();
      const dispatchTimer = setInterval(() => {
        const isLoadingState = getLoadingInProcess(store.getState());
        if (isLoadingState === false) {
          this.setPromotionsData(store);
          clearInterval(dispatchTimer);
        }
      }, 500);
      if (isLoginV2FlowEnabled) {
        this.emailCheckForFailSafe();
      }
      if (typeof window !== 'undefined') {
        const graphqlCachedResponse = getLocalStorage('GRAPHQL_CACHED_RESPONSE');
        window.graphqlQueriesTimeStamps = JSON.parse(graphqlCachedResponse);
        window.callNavigateAPIForExternalLinksGlobal = callNavigateAPIForExternalLinks;
        this.fetchStoreDetails();
      }
      window.testApp = (payload) => {
        store.dispatch(SetTcpSegmentMethodCall(payload));
      };
      window.deviceTier = setDeviceTier();
    } catch (e) {
      const { sessionCookieKey } = API_CONFIG;
      logger.error('Error occurred in Web app.jsx file —> ComponentDidMount: ', {
        error: e,
        extraData: {
          [sessionCookieKey]: generateSessionId(true),
          component: 'componentDidMount inside _app.jsx',
        },
      });
    }
    subscribeScrollRestore(router, store);
  }

  componentDidUpdate() {
    const { store } = this.props;
    const isLoginV2FlowEnabled = getLoginV2FlowEnabled(store.getState());
    if (isLoginV2FlowEnabled) {
      this.emailCheckForFailSafe();
    }
  }

  componentWillUnmount() {
    const { router } = this.props;
    const { isEnableSpeedCurveSPA, isAutomationTC, isBotRequest } = getAPIConfig();
    router.events.off('routeChangeComplete', this.handleRouteChange);
    router.events.off('routeChangeComplete', this.handlePathChange);
    const isAutomationTCValue = parseBoolean(isAutomationTC);
    const isBotRequestValue = parseBoolean(isBotRequest);
    if (isEnableSpeedCurveSPA && window?.LUX && !isAutomationTCValue && !isBotRequestValue)
      router.events.off('routeChangeStart', this.handleRouteChangeStart);
    clearInterval(this.serverTimeInterval);
    unSubscribeScrollRestore(router);
  }

  /**
   * This function parses cookie response
   */
  static parseCookieResponse = ({ name, value }) => {
    let itemValue;
    try {
      itemValue = JSON.parse(value);
    } catch (err) {
      itemValue = {};
    }
    return {
      [name]: itemValue,
    };
  };

  checkForDefaultAfterPayParam = () => {
    const { store } = this.props;
    const params = getAfterPayParam(store.getState());
    const isAfterPaySessionEnabled = parseBoolean(getSessionStorage('defaultAfterPay'));
    if (!isAfterPaySessionEnabled) {
      if (
        window?.location.href?.toString()?.toLowerCase()?.includes(params?.toString().toLowerCase())
      ) {
        setSessionStorage({ key: 'defaultAfterPay', value: true });
      } else {
        setSessionStorage({ key: 'defaultAfterPay', value: false });
      }
    }
  };

  // eslint-disable-next-line complexity
  static loadGlobalData(Component, { store, isServer, req }, pageProps, payload) {
    const initialProps = pageProps;
    // getInitialProps of _App is called on every internal page navigation in spa.
    // This check is to avoid unnecessary api call in those cases
    // Get initial props is getting called twice on server
    // This check ensures this block is executed once since Component is not available in first call
    if (isServer) {
      initialProps.pageData = payload.pageData;
      if (req && req.originalUrl && req.originalUrl.indexOf(SLASH_C_ROUTE) < 0) {
        store.dispatch(bootstrapData({ ...payload, headers: { ...req.headers } }));
      }
      store.dispatch(fetchAllPromotions());
      initialProps.BUILD_DATE = process && process.env && process.env.BUILD_DATE;
      initialProps.PAGE_GENERATION_DATE = new Date();
    }
    return initialProps;
  }

  static async loadComponentData(
    Component,
    { store, isServer, req = {}, query = '', res, asPath },
    pageProps,
    apiConfig,
    bootstrapPayload
  ) {
    let compProps = {};
    if (Component.getInitialProps) {
      try {
        compProps = await Component.getInitialProps(
          { store, isServer, query, req, res, asPath, bootstrapPayload },
          pageProps
        );
      } catch (e) {
        compProps = {};
      }
    }
    if (Component.getInitActions) {
      const actions = Component.getInitActions();
      actions.forEach((action) => store.dispatch(action({ apiConfig: { asPath, ...apiConfig } })));
    }
    return Object.assign({}, pageProps, compProps);
  }

  getSEOTags = (pageId, store, router) => {
    // Just a sample - any store specific data should be set in this
    if (
      pageId &&
      pageId !== 'c' &&
      pageId !== 'p' &&
      pageId !== 'category' &&
      pageId !== 'sizeChart'
    ) {
      const seoConfig = deriveSEOTags(pageId, store, router);
      return seoConfig ? <SEOTags seoConfig={seoConfig} pageId={pageId} router={router} /> : null;
    }
    return null;
  };

  checkNewLoginCheckoutPage = (router) => {
    const { store } = this.props;
    const { loginCheckout } = CHECKOUT_ROUTES;
    const isNewLoginScreen = getIsNewLoginScreen(store?.getState());
    return router?.asPath?.indexOf(loginCheckout?.asPath) > -1 && isNewLoginScreen;
  };

  checkLoginCheckoutPage = (router) => {
    const { loginCheckout } = CHECKOUT_ROUTES;
    const { isMobile = false } = getViewportInfo() || {};
    return router.asPath.indexOf(loginCheckout.asPath) > -1 && isMobile;
  };

  checkShareCartPage = (router) => {
    return router.asPath.indexOf('/sharecart') > -1;
  };

  checkPreCheckoutFlow = (router) => {
    const { loginCheckout } = CHECKOUT_ROUTES;
    const { isDesktop = false } = getViewportInfo() || {};
    return router.asPath.indexOf(loginCheckout.asPath) > -1 && isDesktop;
  };

  checkRegisterCheckoutPage = (router) => {
    const { isMobile = false } = getViewportInfo() || {};
    return router.asPath.indexOf('/register-checkout') > -1 && isMobile;
  };

  checkRegisterPage = (router) => {
    return router.asPath?.includes('/register');
  };

  checkResetPassScreen = (router) => {
    return router.asPath?.includes('/change-password');
  };

  checkTraditionalLoginFlow = (router) => {
    const { store } = this.props;
    const { login } = CHECKOUT_ROUTES;

    const loginFlowUXEnhancementEnabled = getLoginFlowUXEnhancement(store.getState());
    if (!loginFlowUXEnhancementEnabled) {
      return false;
    }
    const loginFlowPaths = [login.asPath, '/register', '/change-password'];
    return loginFlowPaths.some((path) => router.asPath.includes(path));
  };

  checkHideAppBanner = (router) => {
    const { loginCheckout, bagPage, singlePageCheckoutPage } = CHECKOUT_ROUTES;
    return (
      router?.asPath?.indexOf(loginCheckout.asPath) > -1 ||
      router?.asPath?.indexOf(bagPage.asPath) > -1 ||
      router?.asPath?.indexOf(singlePageCheckoutPage.asPath) > -1
    );
  };

  checkHideCountryPopUp = (router) => {
    const PAGE_ROUTES_COUNTRY = {
      BAG: '/bag',
      CHECKOUT: '/checkout',
      ACCOUNT: '/account',
    };
    return (
      router?.asPath?.indexOf(PAGE_ROUTES_COUNTRY.BAG) > -1 ||
      router?.asPath?.indexOf(PAGE_ROUTES_COUNTRY.CHECKOUT) > -1 ||
      router?.asPath?.indexOf(PAGE_ROUTES_COUNTRY.ACCOUNT) > -1
    );
  };

  checkNonCheckoutPage = (router) => {
    let isNonCheckoutPage = true;
    const {
      pickupPage,
      shippingPage,
      billingPage,
      reviewPage,
      internationalCheckout,
      singlePageCheckoutPage,
      spcConfirmationPage,
      internationalCheckoutPayPalReturn,
      loginCheckout,
    } = CHECKOUT_ROUTES;

    let loginCheckoutRoute = [];
    if (this.checkLoginCheckoutPage(router)) {
      loginCheckoutRoute = [loginCheckout.asPath];
    }

    let registerCheckoutPage = [];
    if (this.checkRegisterCheckoutPage(router)) {
      registerCheckoutPage = ['/register-checkout'];
    }

    const checkoutPageURL = [
      pickupPage.asPath,
      shippingPage.asPath,
      billingPage.asPath,
      reviewPage.asPath,
      internationalCheckout.asPath,
      singlePageCheckoutPage.asPath,
      spcConfirmationPage.asPath,
      internationalCheckoutPayPalReturn.asPath,
      ...loginCheckoutRoute,
      ...registerCheckoutPage,
    ];

    for (let i = 0; i < checkoutPageURL.length; i += 1) {
      if (router.asPath.indexOf(checkoutPageURL[i]) > -1) {
        isNonCheckoutPage = false;
      }
    }

    return isNonCheckoutPage;
  };

  checkIsConfirmationPage = (router) => {
    let isConfirmationPage = false;
    const { store } = this.props;

    const { spcConfirmationPage } = CHECKOUT_ROUTES;
    const isConfirmationPageHeaderEnabled = getConfirmationPageHeaderAndButton(store.getState());

    const checkoutPageURL = [spcConfirmationPage?.asPath];
    for (let i = 0; i < checkoutPageURL?.length; i += 1) {
      if (router?.asPath?.indexOf(checkoutPageURL[i]) > -1 && isConfirmationPageHeaderEnabled) {
        isConfirmationPage = true;
      }
    }
    return isConfirmationPage;
  };

  checkIsListingPage = (router) => {
    const listPagePathnames = [PAGE_ROUTES.OLD_PLP, PAGE_ROUTES.SEARCH, PAGE_ROUTES.NEW_PLP];
    return listPagePathnames.indexOf(router.pathname) !== -1;
  };

  checkIsBrowseAnchoredPage = (router) => {
    const browseAnchorPageNames = [
      PAGE_ROUTES.OLD_PLP,
      PAGE_ROUTES.SEARCH,
      PAGE_ROUTES.NEW_PLP,
      PAGE_ROUTES.BAG,
    ];
    return browseAnchorPageNames.indexOf(router.pathname) !== -1;
  };

  checkStaticPage = (router) => {
    const fromMobileAppCookie = readCookie('fromMobileApp') || '';
    let socialPage = false;
    if (fromMobileAppCookie) {
      return true;
    }
    const staticPageUrl = ['twitter', 'instagram', 'hideHeaderFooter=true', 'app-install'];
    for (let i = 0; i < staticPageUrl.length; i += 1) {
      if (router && router.asPath.indexOf(staticPageUrl[i]) > -1) {
        socialPage = true;
      }
    }
    return socialPage;
  };

  checkOmrIDinURl = () => {
    let omRid = '';
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      omRid = (url && url.searchParams && url.searchParams.get('om_rid')) || '';
      if (omRid) {
        setLocalStorage({ key: 'email_hash', value: omRid });
        /* eslint no-underscore-dangle: 0 */
        window._dataLayer.email_hash = omRid;
      }
    }
  };

  checkHomepagePath = (router) =>
    router?.asPath?.indexOf('/home') > -1 || router?.asPath?.includes('/bundle/');

  getExtendedViewClassName = (isPdpPage) => {
    const { store, router } = this.props;
    const isExtendedDisplayKillSwitch = getIsExtendedDisplay(store.getState());
    const isRedesignedPdpDesktopView = getIsRedesignedPdpDesktopView(store.getState());
    const isSLPExtendedView = getIsSlpDesktopView(store.getState());
    const isSlpPage = router?.route === PAGE_ROUTES.SEARCH;
    const isPlpPage = router?.route === PAGE_ROUTES.OLD_PLP;
    const isNewPlpPage = router?.route === PAGE_ROUTES.NEW_PLP;
    const isShopThisStore = router?.route === PAGE_ROUTES.SHOP_THIS_STORE;
    const isNewAccountPage = router?.route === PAGE_ROUTES.ACCOUNT;
    const isNewPJPPDPRedesignEnabled = getIsNewPJPPDPRedesignEnabled(store.getState());

    let extendedViewClassName = '';

    if (isPdpPage && isRedesignedPdpDesktopView) {
      extendedViewClassName = ' extended-view';
    }
    if (isPlpPage && isExtendedDisplayKillSwitch) {
      extendedViewClassName = ' extended-view-plp';
    }
    if (isNewPlpPage || isShopThisStore || (isSlpPage && isSLPExtendedView)) {
      extendedViewClassName = ' extended-new-view';
    }
    if (isPdpPage && isNewPJPPDPRedesignEnabled) {
      extendedViewClassName += ' restricted-view';
    }
    if (isNewAccountPage) {
      extendedViewClassName = ' extended-new-account-page';
    }

    return extendedViewClassName;
  };

  getReloadStatus = (isReloading) => {
    if (isReloading) this.setState({ isReloadEnabled: true }); // Getting data from CHILD component
  };

  fetchStoreDetails = () => {
    const latlong = readCookie('tcpGeoLoc');
    const { store } = this.props;
    if (latlong) {
      let userStore;
      try {
        userStore = JSON.parse(localStorage.getItem('defaultStore')) || '';
      } catch (err) {
        userStore = {};
      }

      let [latitude, longitude] = latlong?.split('|');
      if (userStore?.favStoreTimeStamp && userStore?.basicInfo?.coordinates) {
        latitude = userStore.basicInfo.coordinates.lat;
        longitude = userStore.basicInfo.coordinates.long;
      }

      const inputParams = {
        coordinates: {
          lat: latitude,
          lng: longitude,
        },
        maxItems: 10,
        radius: 75,
        akamaiBasedLogic: true,
      };
      const fetchClosestStore = getFetchClosestStore(store.getState());
      if (fetchClosestStore) {
        store.dispatch(getStoresByCoordinates(inputParams));
      }
    }
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      Component,
      pageProps,
      store,
      router = {},
      GTM_CONTAINER_ID,
      ADOBE_CONTAINER_ID,
      PEGA_MASHUP_SCRIPT_URL,
      PEGA_HELPER_FILE_NAME,
      isChatBotEnabled = true,
    } = this.props;
    const pageVisibilityMsgLabel = renderLabel(
      this.globalGenericLabels.lbl_pageVisibility_msg,
      'lbl_pageVisibility_msg'
    );
    const { isMobile } = getViewportInfo() || {};
    const componentPageName = Component.pageInfo ? Component.pageInfo.name || '' : '';
    const isPdpPage = router?.asPath?.includes('/p/');
    const { brandId = '', isAppChannel = false } = store.getState().APIConfig;
    const isNonCheckoutPage = this.checkNonCheckoutPage(router);
    const isConfirmationPage = this.checkIsConfirmationPage(router);
    const isLoginCheckoutPage = this.checkLoginCheckoutPage(router);
    const isNewLoginCheckoutPage = this.checkNewLoginCheckoutPage(router);
    const isNewLoginCheckoutPageMobile = this.checkNewLoginCheckoutPage(router) && isMobile;
    const isShareCartPage = this.checkShareCartPage(router);
    const isRegisterCheckoutPage = this.checkRegisterCheckoutPage(router);
    const isTraditionalLoginFlow = this.checkTraditionalLoginFlow(router);
    const isPreCheckoutFlow = this.checkPreCheckoutFlow(router) || isTraditionalLoginFlow;
    const isListingPage = this.checkIsListingPage(router);
    const isRegisterPage = this.checkRegisterPage(router);
    const isResetPassScreen = this.checkResetPassScreen(router);
    const isStaticPage = this.checkStaticPage(router);
    const isBrowseAnchoredPage = this.checkIsBrowseAnchoredPage(router);
    const loginFlowUXEnhancementEnabled = getLoginFlowUXEnhancement(store.getState());

    const checkSSR =
      !isAppChannel &&
      !isStaticPage &&
      pageProps &&
      !isLoginCheckoutPage &&
      !isRegisterCheckoutPage &&
      !isShareCartPage;
    this.checkBootstrapErrors();
    const emailHashInLocalStorage = getLocalStorage('email_hash');
    const isReloadOnInactivity = getIsReloadOnInactivity(store.getState());
    const isReloadOnInactivityPostSpecifiedTime = getIsReloadOnInactivityPostSpecifiedTime(
      store.getState()
    );
    const inactivityTimeInterval = getInActivityTimeInterval(store.getState());
    const timeToReloadPageInEST = getTimeToReloadPageInEST(store.getState());
    const isHideAppBanner =
      this.checkHideAppBanner(router) || isShareCartPage || isConfirmationPage;
    const UserAdobe = getUserState(store.getState());
    const APIConfigAdobe = getAPIConfigForAdobe(store.getState());
    const sessionAdobe = getSessionDataForAdobe(store.getState());
    const showSiteCookiesDisclaimer = getShowSiteCookiesDisclaimer(store.getState());
    const showRedirectModalDisclaimer = getRedirectModalDisclaimer(store.getState());
    const isHomePagePath = this.checkHomepagePath(router);
    const isHomepageFullPageWidthEnabled = getIsHomepageFullPageWidthEnabled(store.getState());
    const isHideCountryPopUp = this.checkHideCountryPopUp(router);
    const isFooterRedesignEnabled = getIsFooterRedesignEnabled(store.getState());
    const confettiAnimationParams = getConfettiAnimationParams(store.getState());

    /* eslint no-underscore-dangle: 0 */
    if (emailHashInLocalStorage) {
      if (window) {
        window._dataLayer.email_hash = emailHashInLocalStorage;
      }
    } else {
      this.checkOmrIDinURl();
    }
    // TO DO: Move the killswitch and abtest to components
    const extendedPageClass = this.getExtendedViewClassName(isPdpPage);
    const lazyLoadConfig = {
      placeholder: (
        <FooterSkeleton
          isPreCheckoutFlow={isPreCheckoutFlow}
          isFooterRedesignEnabled={isFooterRedesignEnabled}
        />
      ),
    };
    if (isNonCheckoutPage) Footer.lazyLoadConfig = lazyLoadConfig;
    if (this.isShowFooter === undefined) {
      this.isShowFooter = (pageProps && pageProps.isBotDevice) || isPdpPage;
    }
    const FooterModule = this.isShowFooter ? Footer : withLazyLoad(Footer);

    const checkoutCssClass = this.checkRegisterCheckoutPage(router)
      ? 'checkout-pages'
      : 'checkout-pages full-background';

    const componentPageId = Component?.pageInfo?.pageId;
    const isChatIconToBeDisplayed =
      componentPageId === 'Home' || componentPageId === 'p' || isListingPage;
    let classForMinHeight = '';
    const getMinHeightClass = (page) => {
      let pageHeight = '';
      Object.entries(PageMinHeight[page]).every((d) => {
        const [pageName, styleName] = d;
        if (router?.asPath?.indexOf(pageName) > -1) {
          pageHeight = styleName;
          return false;
        }
        return true;
      });
      return pageHeight;
    };
    if (!isPreCheckoutFlow && isNonCheckoutPage) {
      if (router?.asPath?.indexOf('account') > -1) {
        classForMinHeight = getMinHeightClass('account');
      } else {
        classForMinHeight = getMinHeightClass('otherPages');
      }
      classForMinHeight = classForMinHeight || 'mainPageHeight';
    }

    // router is send to category page only because withRouter is removed from CLP container
    // pdp url was coming as asPath when back from pdp to plp inside clp container, Removing withRouter solves the problem
    if (componentPageId === 'category') {
      pageProps.router = router;
    }

    if (router?.state?.query.contentType === 'size-chart') {
      Component.pageInfo.pageId = 'sizeChart';
    }

    let classNameValue = '';
    if (isNonCheckoutPage) {
      classNameValue = 'non-checkout-pages';
    } else if (isConfirmationPage) {
      classNameValue = 'non-checkout-pages confirmation-pages full-background';
    } else {
      classNameValue = checkoutCssClass;
    }
    let overrideOverlayClassName = '';
    if (isHomepageFullPageWidthEnabled && isHomePagePath) {
      overrideOverlayClassName = 'homepage-full-width-content-wrapper';
    } else {
      overrideOverlayClassName = 'content-wrapper';
    }

    const { hasMounted } = this.state;
    const hideFooter = loginFlowUXEnhancementEnabled && isTraditionalLoginFlow && isMobile;
    return (
      <>
        <div className="dark-overlay" />
        <ThemeProvider theme={this.theme}>
          <Provider store={store}>
            <LabelsProvider>
              <PageVisibility
                isReloadOnInactivity={isReloadOnInactivity}
                inactivityTimeInterval={inactivityTimeInterval}
                callbackFunc={this.getReloadStatus}
                isReloadOnInactivityPostSpecifiedTime={isReloadOnInactivityPostSpecifiedTime}
                timeToReloadPageInEST={timeToReloadPageInEST}
                router={router}
              >
                <>
                  {hasMounted && <SiteMaintenanceBannerContainer />}
                  <GlobalStyle isHideAppBanner={isHideAppBanner} />
                  {!isHideAppBanner && !isAppChannel && !isStaticPage ? (
                    <AppBanner isBrowseAnchoredPage={isBrowseAnchoredPage} asPath={router.asPath} />
                  ) : null}
                  <div className={classNameValue}>
                    {Component.pageInfo && Component.pageInfo.pageId
                      ? this.getSEOTags(Component.pageInfo.pageId, store, router)
                      : null}
                    {!isAppChannel && !isStaticPage && !isShareCartPage && (
                      <>
                        {(!isLoginCheckoutPage || isNewLoginCheckoutPage) &&
                          (!isRegisterCheckoutPage || isTraditionalLoginFlow) && (
                            <>
                              {(isNonCheckoutPage || isConfirmationPage) &&
                              !isPreCheckoutFlow &&
                              !isNewLoginCheckoutPageMobile ? (
                                <HeaderNew
                                  router={router}
                                  isConfirmationPageRoute={isConfirmationPage}
                                />
                              ) : (
                                <DynamicModule
                                  key="checkout-header"
                                  isPreCheckoutFlow={isPreCheckoutFlow || isNewLoginCheckoutPage}
                                  importCallback={() =>
                                    import(
                                      /* webpackChunkName: "checkout-header" */ '../components/features/content/CheckoutHeaderNew'
                                    )
                                  }
                                />
                              )}
                            </>
                          )}
                      </>
                    )}
                    <Loader />
                    <HelpMenu isChatIconToBeDisplayed={isChatIconToBeDisplayed} />
                    {/* Provider for global hotfixes object */}
                    <HotfixPropsContext.Provider value={global.TCP_HOTFIX_PROPS || {}}>
                      <HotfixBrowserContext.Provider value={global.TCP_HOTFIX_BROWSER || {}}>
                        <div id="web-app-content" className={`app-content ${classForMinHeight}`}>
                          <div
                            id="overlayWrapper"
                            className={`${overrideOverlayClassName} ${extendedPageClass} ${
                              isPreCheckoutFlow ? 'app-content-pre-checkout-pages' : ''
                            } ${
                              isTraditionalLoginFlow ? 'app-content-traditional-login-pages' : ''
                            }`}
                          >
                            <div id="overlayComponent" />
                            {this.state.isLabelsLoaded && (
                              <Component
                                {...pageProps}
                                pageName={componentPageName}
                                isPdpPage={isPdpPage}
                              />
                            )}
                          </div>
                        </div>
                      </HotfixBrowserContext.Provider>
                    </HotfixPropsContext.Provider>
                    {checkSSR && !hideFooter && (
                      <FooterModule
                        pageName={componentPageName}
                        isPdpPage={isPdpPage}
                        isPreCheckoutFlow={isPreCheckoutFlow}
                        isRegisterPage={loginFlowUXEnhancementEnabled && isRegisterPage}
                        isResetPassScreen={loginFlowUXEnhancementEnabled && isResetPassScreen}
                      />
                    )}
                    <GlobalModals />
                    <div className="redirection-and-cookies-disclaimer-wrapper">
                      {showRedirectModalDisclaimer &&
                        !isHideCountryPopUp &&
                        !isAppChannel &&
                        !isStaticPage && <RedirectModalContainer />}
                      {showSiteCookiesDisclaimer && !isAppChannel && !isStaticPage && (
                        <SiteCookiesDisclaimer />
                      )}
                    </div>
                  </div>
                  {/* Inject route tracker to track number of page visits. */}

                  {isClient() && (
                    <RouteTracker
                      brandId={brandId}
                      router={router}
                      APIConfig={APIConfigAdobe}
                      User={UserAdobe}
                      session={sessionAdobe}
                    />
                  )}
                  <AbTestPathTracker />
                  {this.state.isReloadEnabled ? (
                    <PageVisibilityModal
                      isOpen={this.state.isReloadEnabled}
                      overlayClassName="TCPModal__Overlay page-visibility"
                      className="TCPModal__PageVisibility"
                      horizontalBar={false}
                      inheritedStyles={modalStyles}
                    >
                      <span className="pageVisibility-modal-text">{pageVisibilityMsgLabel}</span>
                    </PageVisibilityModal>
                  ) : (
                    <></>
                  )}
                  {!isEmpty(confettiAnimationParams) ? (
                    <ConfettiCelebration {...confettiAnimationParams} routerPath={router?.asPath} />
                  ) : null}
                  {checkSSR && this.logLabelReceivedValue()}
                </>
              </PageVisibility>
            </LabelsProvider>
          </Provider>
        </ThemeProvider>
        {/* Inject UX timer reporting if enabled. */}
        {process.env.PERF_TIMING && <UserTimingRouteHandler />}
        <ThirdPartyScript
          GTM_CONTAINER_ID={GTM_CONTAINER_ID}
          PEGA_MASHUP_SCRIPT_URL={PEGA_MASHUP_SCRIPT_URL}
          PEGA_HELPER_FILE_NAME={PEGA_HELPER_FILE_NAME}
          isChatBotEnabled={isChatBotEnabled}
          ADOBE_CONTAINER_ID={ADOBE_CONTAINER_ID}
        />
      </>
    );
  }
}

export default withRedux(configStore)(withReduxSaga(TCPWebApp));
